import Plyr from 'plyr';
import Flickity from 'flickity';

const wave: LegacyModule = {
	init: function () {
		this.cache();
		this.initPlayers();
	},

	cache: function () {
		this.$playerWrappers = document.querySelectorAll('.waveWrapper .js-player video');
	},

	initPlayers: function () {
		this.players = Array.from(this.$playerWrappers as NodeListOf<HTMLVideoElement>).map(
			function (p) {
				return new Plyr(p);
			}
		);
		Array.from(this.$playerWrappers as NodeListOf<HTMLVideoElement>).forEach(function (p) {
			p.classList.add('wavePlayer');
		});
	},
};
wave.init();

const waveGallery: LegacyModule = {
	init: function () {
		this.cache();
		if (!this.$rotator) return;
		this.rotator();
		this.initPlayers();
	},

	cache: function () {
		this.$rotator = document.querySelector('.waveGallery .rotator');
		this.$playerWrappers = document.querySelectorAll('.waveGallery .js-galleryPlayer video');
	},

	rotator: function () {
		this.rotator = new Flickity(this.$rotator, {
			pageDots: window.outerWidth < 1000,
		});
		this.rotator.on('change', this.rotate.bind(this));
	},

	initPlayers: function () {
		this.players = Array.from(this.$playerWrappers as NodeListOf<HTMLVideoElement>).map(
			function (p) {
				return new Plyr(p, { ratio: '16:9' });
			}
		);
	},

	rotate: function () {
		this.players.forEach(function (p) {
			p.pause();
		});
	},
};
waveGallery.init();

const waveBuild: LegacyModule = {
	slide: 0,

	init: function () {
		this.cache();
		this.events();
		this.rotator();
		this.setIndicator(0);
	},

	cache: function () {
		this.$nav = document.querySelector('.waveBuildTabs .nav');
		this.$indicator = document.querySelector('.waveBuildTabs .indicator');
		this.$navItems = document.querySelectorAll('.waveBuildTabs .navItem');
		this.$tabs = document.querySelector('.waveBuildTabs .tabs');
	},

	events: function () {
		if (this.$nav) this.$nav.addEventListener('mouseleave', this.navMouseLeave.bind(this));
		for (var i = 0; i < this.$navItems.length; i++) {
			this.$navItems[i].addEventListener('click', this.navClick.bind(this));
			this.$navItems[i].addEventListener('mouseenter', this.navMouseEnter.bind(this));
		}
	},

	navClick: function (e) {
		var index = e.currentTarget.getAttribute('data-index');
		this.rotator.select(index);
		this.setIndicator(index);
		this.slide = index;
		for (var i = 0; i < this.$navItems.length; i++) {
			this.$navItems[i].classList.remove('active');
		}
		e.currentTarget.classList.add('active');
	},

	navMouseLeave: function () {
		this.setIndicator(this.slide);
	},

	navMouseEnter: function (e) {
		var index = e.currentTarget.getAttribute('data-index');
		this.setIndicator(index);
	},

	setIndicator: function (i) {
		if (!this.$nav) return;
		var navRect = this.$nav.getBoundingClientRect();
		var rect = this.$navItems[i].getBoundingClientRect();
		var position = rect.left - navRect.left;
		this.$indicator.style.transform = 'translateX(' + position + 'px)';
	},

	rotator: function () {
		if (!this.$tabs) return;
		this.rotator = new Flickity(this.$tabs, {
			contain: true,
			prevNextButtons: false,
			pageDots: false,
			draggable: false,
		});
	},
};
waveBuild.init();

const waveAdaptable: LegacyModule = {
	slide: 0,

	init: function () {
		this.cache();
		this.events();
		this.rotator();
		this.setIndicator(0);
	},

	cache: function () {
		this.$nav = document.querySelector('.waveAdaptableTabs .nav');
		this.$indicator = document.querySelector('.waveAdaptableTabs .indicator');
		this.$navItems = document.querySelectorAll('.waveAdaptableTabs .navItem');
		this.$tabs = document.querySelector('.waveAdaptableTabs .tabs');
	},

	events: function () {
		if (this.$nav) this.$nav.addEventListener('mouseleave', this.navMouseLeave.bind(this));
		for (var i = 0; i < this.$navItems.length; i++) {
			this.$navItems[i].addEventListener('click', this.navClick.bind(this));
			this.$navItems[i].addEventListener('mouseenter', this.navMouseEnter.bind(this));
		}
	},

	navClick: function (e) {
		var index = e.currentTarget.getAttribute('data-index');
		this.rotator.select(index);
		this.setIndicator(index);
		this.slide = index;
		for (var i = 0; i < this.$navItems.length; i++) {
			this.$navItems[i].classList.remove('active');
		}
		e.currentTarget.classList.add('active');
	},

	navMouseLeave: function () {
		this.setIndicator(this.slide);
	},

	navMouseEnter: function (e) {
		var index = e.currentTarget.getAttribute('data-index');
		this.setIndicator(index);
	},

	setIndicator: function (i) {
		if (!this.$nav) return;
		var navRect = this.$nav.getBoundingClientRect();
		var rect = this.$navItems[i].getBoundingClientRect();
		var position = rect.left - navRect.left;
		this.$indicator.style.transform = 'translateX(' + position + 'px)';
	},

	rotator: function () {
		if (!this.$tabs) return;
		this.rotator = new Flickity(this.$tabs, {
			contain: true,
			prevNextButtons: false,
			pageDots: false,
			draggable: false,
		});
	},
};
waveAdaptable.init();
